import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Are you sure you want to delete this option? This action is "),
  /*#__PURE__*/_createElementVNode("strong", null, "irreversible"),
  /*#__PURE__*/_createTextVNode(". ")
], -1 /* HOISTED */)
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Delete option",
    onCloseModal: _cache[1] || (_cache[1] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _hoisted_1,
      ($setup.error_message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.error_message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel "),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill-danger", { 'button--loading': $setup.loading }]),
        onClick: $setup.deleteTheOption
      }, " Delete ", 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }))
}